import { readable, writable } from 'svelte/store';

export const familyNames = readable ({
    HCT: [
        {name: 'Blush', min: 0, max: 10},
        {name: 'Red', min: 10, max: 36},
        {name: 'Orange', min: 36, max: 91},
        {name: 'Yellow', min: 91, max: 110},
        {name: 'Chartreuse Green', min: 110, max: 136},
        {name: 'Green', min: 136, max: 171},
        {name: 'Mint Green', min: 171, max: 188},
        {name: 'Cyan', min: 188, max: 208},
        {name: 'Sky Blue', min: 208, max: 260},
        {name: 'Blue', min: 260, max: 287},
        {name: 'Purple', min: 287, max: 325},
        {name: 'Magenta', min: 325, max: 343},
        {name: 'Blush', min: 343, max: 360}
    ],
    HSL: [
        {name: 'Red', min: 0, max: 15},
        {name: 'Orange', min: 15, max: 45},
        {name: 'Yellow', min: 45, max: 75},
        {name: 'Chartreuse Green', min: 75, max: 105},
        {name: 'Green', min: 105, max: 135},
        {name: 'Mint Green', min: 135, max: 165},
        {name: 'Cyan', min: 165, max: 195},
        {name: 'Sky Blue', min: 195, max: 225},
        {name: 'Blue', min: 225, max: 255},
        {name: 'Purple', min: 255, max: 285},
        {name: 'Magenta', min: 285, max: 315},
        {name: 'Blush', min: 315, max: 345},
        {name: 'Red', min: 345, max: 360}
    ]
})

// make these color names available right away here
// let baseColorNamesS;
// baseColorNames.subscribe(value => {
//     baseColorNamesS = value;
// });
// let hctColorNamesS;
// hctColorNames.subscribe(value => {
//     hctColorNamesS = value;
// });
// familyNames.subscribe(value => {
//     familyNames = value;
// });

// let startingHue = Math.round(Math.random() * 360);
// let startingName = baseColorNamesS[Math.round((startingHue / 360) * baseColorNamesS.length)];

export const lightnessParamsS = writable({
    min: 10,
    max: 90,
    steps: 10,
    method: 'Linear'
});

export const familiesS = writable([{
    id: '0',
    name: 'Blue',
    hue: 226,
    saturation: 83,
    swatchGroup: [],
    anchorPref: false
}]);

export const prefs = writable({
    exportColorFormat: 'Hex',
    exportAccessibility: false,
    exportCodeType: 'SVG',
    swatchHex: false,
    swatchLabel: true,
    swatchA11y: false,
    swatchA11yLarge: false,
    swatchSeperation: false,
    swatchRounded: false,
    textColors: [
        {
            valid: true,
            hex: 'ffffff',
            rgb: {r:255, g:255, b:255},
            luminance: ''
        },{
            valid: true,
            hex: '000000',
            rgb: {r:0, g:0, b:0},
            luminance: ''
        },{
            valid: false,
            hex: '',
            rgb: {},
            luminance: ''
        },{
            valid: false,
            hex: '',
            rgb: {},
            luminance: ''
        }
    ],
    showOptions: true,
    harmony: 'none',
    theme: 'System',
    colorSpace: 'HSL'
});

export const appState = writable({
    family: '', // -1 means none selected
    familySelected: false,
    familySelectedIndex: 0, // this helps track when user rearranges order of families
    global: -1, // -1 means no global setting is selected
    view: 0,
    familyOption: 0,
    modalOpen: false,
    modalContent: undefined,
    notifications: [],
    notificationCounter: 0
});

export const windowWidth = writable(0);